import React, { useState } from "react";
import Breadcrumb from "../../../../core/common/Breadcrumb/breadcrumb";
import { Link } from "react-router-dom";
import ProfileCard from "../../common/profileCard";
import StudentSidebar from "../../common/studentSidebar";
import SettingsLinks from "../settingsLinks/settingsLinks";
import SettingsModal from "../settingsModal/settingsModal";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { User } from "../../../../core/types/types";
import { updateUser } from "../../../../core/redux/authSlice";
import CustomSelect from "../../../../core/common/commonSelect";
import { Country } from "../../../../core/common/selectOption/json/selectOption";
import apiInstance from "../../../../utility/apiInstance";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const StudentTestScores = () => {

    const user = useSelector((state: any) => state.auth.user);
    const dispatch = useDispatch();

    const getModalContainer = () => {
        const modalElement = document.getElementById("add_assignment");
        return modalElement ? modalElement : document.body;
    };

    const [msg, setMsg] = useState({
        error: false,
        loading: false,
        text: ''
    });

   const [formData, setFormData] = useState<User>({
       id: user?.id || "",
       testScores: {
           toefl: {
               available: "no",
               reading: "",
               listening: "",
               writing: "",
               speaking: "",
               dateOfExam: "",
               ...user?.testScores?.toefl,
           },
           ielts: {
               available: "no",
               reading: "",
               listening: "",
               writing: "",
               speaking: "",
               dateOfExam: "",
               ...user?.testScores?.ielts,
           },
           pte: {
               available: "no",
               totalScore: "",
               reading: "",
               listening: "",
               writing: "",
               speaking: "",
               dateOfExam: "",
               ...user?.testScores?.pte,
           },
           duolingo: {
               available: "no",
               totalScore: "",
               dateOfExam: "",
               ...user?.testScores?.duolingo,
           },
           gmat: {
               available: "no",
               total: "",
               verbal: "",
               quantitative: "",
               awa: "",
               dateOfExam: "",
               ...user?.testScores?.gmat,
           },
           gre: {
               available: "no",
               verbal: "",
               quantitative: "",
               awa: "",
               dateOfExam: "",
               ...user?.testScores?.gre,
           },
       },
   });


    const sanitizeScore = (value: string) => {
        const numericOnly = value.replace(/[^0-9.]/g, '');
        const parts = numericOnly.split('.');
        return parts.length > 2 ? parts[0] + '.' + parts.slice(1).join('') : numericOnly;
    };

    const handleScoreChange = (
        section: keyof NonNullable<User['testScores']>,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        e.target.value = sanitizeScore(e.target.value);
        handleInputChange(section, e);
    };

    const handleInputChange = (
        section: keyof NonNullable<User['testScores']>,
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            testScores: {
                ...prev.testScores,
                [section]: {
                    ...prev.testScores?.[section],
                    [name]: value,
                },
            },
        }));
    };

    const handleCheckboxChange = (
        section: keyof NonNullable<User['testScores']>,
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | any>,
    ) => {
        const { name, checked } = e.target;

        setFormData((prev) => ({
            ...prev,
            testScores: {
                ...prev.testScores,
                [section]: {
                    ...prev.testScores?.[section],
                    [name]: checked ? 'yes' : 'no',
                },
            },
        }));
    };

    const updateProfile = async (e: React.FormEvent) => {
        e.preventDefault();

        setMsg({
            error: false,
            loading: true,
            text: ''
        });

        try {
            const response = await apiInstance.patch(`/api/users/${formData.id}`, formData)
            dispatch(updateUser(response.data.doc))
            setMsg({
                error: false,
                loading: false,
                text: 'Test scores updated successfully!'
            });

        } catch (error: any) {
            setMsg({
                error: true,
                loading: false,
                text: error.message
            });
        }
    }

    return (
        <>
            <div className="content">
                <div className="container">
                    {/* P[name]: valurofile */}
                    <ProfileCard />
                    {/* /Profile */}
                    <div className="row">
                        {/* Sidebar */}
                        <StudentSidebar />
                        {/* Sidebar */}
                        <div className="col-lg-9">
                            <div className="mb-3">
                                <h5>Settings</h5>
                            </div>
                            <SettingsLinks />
                            <div className="card">
                                <div className="card-body">
                                    <div>
                                        <div className="edit-profile-info mb-3">
                                            <h5 className="mb-1">English Test Scores</h5>
                                        </div>
                                        <div className="row">

                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="edit-profile-info mb-3 d-flex justify-content-between mt-3">
                                                            <h6 className="mb-1">TOEFL</h6>
                                                            <div className="form-check form-switch cursor-pointer">
                                                                <input
                                                                    className="form-check-input cursor-pointer"
                                                                    type="checkbox"
                                                                    checked={formData.testScores?.toefl?.available === "yes"}
                                                                    name="available"
                                                                    onChange={(e) => {
                                                                        handleCheckboxChange('toefl', e)
                                                                    }}

                                                                />
                                                            </div>
                                                        </div>
                                                        
                                                        {formData.testScores?.toefl?.available === "yes" && (
                                                            <>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Reading
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="reading"
                                                                            value={formData.testScores?.toefl?.reading || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('toefl', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Listening
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="listening"
                                                                            value={formData.testScores?.toefl?.listening || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('toefl', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Writing
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="writing"
                                                                            value={formData.testScores?.toefl?.writing || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('toefl', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Speaking
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="speaking"
                                                                            value={formData.testScores?.toefl?.speaking || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('toefl', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Date of Exam
                                                                        </label>
                                                                        <div className="input-icon-start position-relative">
                                                                            <span className="input-icon-addon">
                                                                                <i className="isax isax-calendar" />
                                                                            </span>

                                                                            <DatePicker
                                                                                name="from"
                                                                                className="form-control datetimepicker"
                                                                                getPopupContainer={getModalContainer}
                                                                                placeholder="Select Date"
                                                                                format="DD/MM/YYYY"
                                                                                onChange={(date) => {
                                                                                    handleInputChange('toefl', {
                                                                                        target: {
                                                                                            name: 'dateOfExam',
                                                                                            value: date ? date.format('YYYY-MM-DD') : ''
                                                                                        }
                                                                                    } as any);
                                                                                }}
                                                                                value={formData.testScores?.toefl?.dateOfExam ? dayjs(formData.testScores?.toefl?.dateOfExam) : null}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="edit-profile-info mb-3 d-flex justify-content-between mt-3">
                                                            <h6 className="mb-1">IELTS</h6>
                                                            <div className="form-check form-switch cursor-pointer">
                                                                <input
                                                                    className="form-check-input cursor-pointer"
                                                                    type="checkbox"
                                                                    checked={formData.testScores?.ielts?.available === "yes"}
                                                                    name="available"
                                                                    onChange={(e) => {
                                                                        handleCheckboxChange('ielts', e)
                                                                    }}

                                                                />
                                                            </div>
                                                        </div>
                                                        {formData.testScores?.ielts?.available === "yes" && (
                                                            <>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Reading
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="reading"
                                                                            value={formData.testScores?.ielts?.reading || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('ielts', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Listening
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="listening"
                                                                            value={formData.testScores?.ielts?.listening || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('ielts', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Writing
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="writing"
                                                                            value={formData.testScores?.ielts?.writing || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('ielts', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Speaking
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="speaking"
                                                                            value={formData.testScores?.ielts?.speaking || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('ielts', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Date of Exam
                                                                        </label>
                                                                        <div className="input-icon-start position-relative">
                                                                            <span className="input-icon-addon">
                                                                                <i className="isax isax-calendar" />
                                                                            </span>

                                                                            <DatePicker
                                                                                name="from"
                                                                                className="form-control datetimepicker"
                                                                                getPopupContainer={getModalContainer}
                                                                                placeholder="Select Date"
                                                                                format="DD/MM/YYYY"
                                                                                onChange={(date) => {
                                                                                    handleInputChange('ielts', {
                                                                                        target: {
                                                                                            name: 'dateOfExam',
                                                                                            value: date ? date.format('YYYY-MM-DD') : ''
                                                                                        }
                                                                                    } as any);
                                                                                }}
                                                                                value={formData.testScores?.ielts?.dateOfExam ? dayjs(formData.testScores?.ielts?.dateOfExam) : null}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="edit-profile-info mb-3 d-flex justify-content-between mt-3">
                                                            <h6 className="mb-1">PTE</h6>
                                                            <div className="form-check form-switch cursor-pointer">
                                                                <input
                                                                    className="form-check-input cursor-pointer"
                                                                    type="checkbox"
                                                                    checked={formData.testScores?.pte?.available === "yes"}
                                                                    name="available"
                                                                    onChange={(e) => {
                                                                        handleCheckboxChange('pte', e)
                                                                    }}

                                                                />
                                                            </div>
                                                        </div>
                                                        {formData.testScores?.pte?.available === "yes" && (
                                                            <>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Total Score
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="totalScore"
                                                                            value={formData.testScores?.pte?.totalScore || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('pte', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Reading
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="reading"
                                                                            value={formData.testScores?.pte?.reading || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('pte', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Listening
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="listening"
                                                                            value={formData.testScores?.pte?.listening || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('pte', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Writing
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="writing"
                                                                            value={formData.testScores?.pte?.writing || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('pte', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Speaking
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="speaking"
                                                                            value={formData.testScores?.pte?.speaking || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('pte', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Date of Exam
                                                                        </label>
                                                                        <div className="input-icon-start position-relative">
                                                                            <span className="input-icon-addon">
                                                                                <i className="isax isax-calendar" />
                                                                            </span>

                                                                            <DatePicker
                                                                                name="from"
                                                                                className="form-control datetimepicker"
                                                                                getPopupContainer={getModalContainer}
                                                                                placeholder="Select Date"
                                                                                format="DD/MM/YYYY"
                                                                                onChange={(date) => {
                                                                                    handleInputChange('pte', {
                                                                                        target: {
                                                                                            name: 'dateOfExam',
                                                                                            value: date ? date.format('YYYY-MM-DD') : ''
                                                                                        }
                                                                                    } as any);
                                                                                }}
                                                                                value={formData.testScores?.pte?.dateOfExam ? dayjs(formData.testScores?.pte?.dateOfExam) : null}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="edit-profile-info mb-3 d-flex justify-content-between mt-3">
                                                            <h6 className="mb-1">duolingo</h6>
                                                            <div className="form-check form-switch cursor-pointer">
                                                                <input
                                                                    className="form-check-input cursor-pointer"
                                                                    type="checkbox"
                                                                    checked={formData.testScores?.duolingo?.available === "yes"}
                                                                    name="available"
                                                                    onChange={(e) => {
                                                                        handleCheckboxChange('duolingo', e)
                                                                    }}

                                                                />
                                                            </div>
                                                        </div>
                                                        {formData.testScores?.duolingo?.available === "yes" && (
                                                            <>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Total Score
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="totalScore"
                                                                            value={formData.testScores?.duolingo?.totalScore || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('duolingo', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Date of Exam
                                                                        </label>
                                                                        <div className="input-icon-start position-relative">
                                                                            <span className="input-icon-addon">
                                                                                <i className="isax isax-calendar" />
                                                                            </span>

                                                                            <DatePicker
                                                                                name="from"
                                                                                className="form-control datetimepicker"
                                                                                getPopupContainer={getModalContainer}
                                                                                placeholder="Select Date"
                                                                                format="DD/MM/YYYY"
                                                                                onChange={(date) => {
                                                                                    handleInputChange('duolingo', {
                                                                                        target: {
                                                                                            name: 'dateOfExam',
                                                                                            value: date ? date.format('YYYY-MM-DD') : ''
                                                                                        }
                                                                                    } as any);
                                                                                }}
                                                                                value={formData.testScores?.duolingo?.dateOfExam ? dayjs(formData.testScores?.duolingo?.dateOfExam) : null}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <div>
                                        <div className="edit-profile-info mb-3">
                                            <h5 className="mb-1">GRE/GMAT Test Scores</h5>
                                        </div>
                                        <div className="row">

                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="edit-profile-info mb-3 d-flex justify-content-between mt-3">
                                                            <h6 className="mb-1">GRE</h6>
                                                            <div className="form-check form-switch cursor-pointer">
                                                                <input
                                                                    className="form-check-input cursor-pointer"
                                                                    type="checkbox"
                                                                    checked={formData.testScores?.gre?.available === "yes"}
                                                                    name="available"
                                                                    onChange={(e) => {
                                                                        handleCheckboxChange('gre', e)
                                                                    }}

                                                                />
                                                            </div>
                                                        </div>
                                                        {formData.testScores?.gre?.available === "yes" && (
                                                            <>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Verbal
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="verbal"
                                                                            value={formData.testScores?.gre?.verbal || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('gre', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Quantitative
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="quantitative"
                                                                            value={formData.testScores?.gre?.quantitative || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('gre', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            AWA
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="awa"
                                                                            value={formData.testScores?.gre?.awa || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('gre', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Date of Exam
                                                                        </label>
                                                                        <div className="input-icon-start position-relative">
                                                                            <span className="input-icon-addon">
                                                                                <i className="isax isax-calendar" />
                                                                            </span>

                                                                            <DatePicker
                                                                                name="from"
                                                                                className="form-control datetimepicker"
                                                                                getPopupContainer={getModalContainer}
                                                                                placeholder="Select Date"
                                                                                format="DD/MM/YYYY"
                                                                                onChange={(date) => {
                                                                                    handleInputChange('gre', {
                                                                                        target: {
                                                                                            name: 'dateOfExam',
                                                                                            value: date ? date.format('YYYY-MM-DD') : ''
                                                                                        }
                                                                                    } as any);
                                                                                }}
                                                                                value={formData.testScores?.gre?.dateOfExam ? dayjs(formData.testScores?.gre?.dateOfExam) : null}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="edit-profile-info mb-3 d-flex justify-content-between mt-3">
                                                            <h6 className="mb-1">GMAT</h6>
                                                            <div className="form-check form-switch cursor-pointer">
                                                                <input
                                                                    className="form-check-input cursor-pointer"
                                                                    type="checkbox"
                                                                    checked={formData.testScores?.gmat?.available === "yes"}
                                                                    name="available"
                                                                    onChange={(e) => {
                                                                        handleCheckboxChange('gmat', e)
                                                                    }}

                                                                />
                                                            </div>
                                                        </div>
                                                        {formData.testScores?.gmat?.available === "yes" && (
                                                            <>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Total Score
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="total"
                                                                            value={formData.testScores?.gmat?.total || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('gmat', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Verbal
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="verbal"
                                                                            value={formData.testScores?.gmat?.verbal || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('gmat', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Quantitative
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="quantitative"
                                                                            value={formData.testScores?.gmat?.quantitative || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('gmat', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            AWA
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            defaultValue=""
                                                                            name="awa"
                                                                            value={formData.testScores?.gmat?.awa || ''}
                                                                            onChange={(e) => {
                                                                                handleScoreChange('gmat', e);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="mb-3">
                                                                        <label className="form-label">
                                                                            Date of Exam
                                                                        </label>
                                                                        <div className="input-icon-start position-relative">
                                                                            <span className="input-icon-addon">
                                                                                <i className="isax isax-calendar" />
                                                                            </span>

                                                                            <DatePicker
                                                                                name="from"
                                                                                className="form-control datetimepicker"
                                                                                getPopupContainer={getModalContainer}
                                                                                placeholder="Select Date"
                                                                                format="DD/MM/YYYY"
                                                                                onChange={(date) => {
                                                                                    handleInputChange('gmat', {
                                                                                        target: {
                                                                                            name: 'dateOfExam',
                                                                                            value: date ? date.format('YYYY-MM-DD') : ''
                                                                                        }
                                                                                    } as any);
                                                                                }}
                                                                                value={formData.testScores?.gmat?.dateOfExam ? dayjs(formData.testScores?.gmat?.dateOfExam) : null}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <button
                                    className="btn btn-secondary rounded-pill"
                                    type="submit"
                                    onClick={updateProfile}
                                >
                                    Save
                                </button>
                                {msg.loading &&
                                    <span className="mt-3 fs-14 fw-normal d-flex align-items-center justify-content-center">Updating test scores...</span>
                                }
                                {!msg.loading &&
                                    <span className={`mt-3 ${msg.error ? 'text-red' : ''} fs-14 fw-normal d-flex align-items-center justify-content-center`}>{msg.text}</span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SettingsModal />
        </>
    );
};

export default StudentTestScores;
